var map = {
	"../pages/cliente-detail/cliente-detail.module": [
		337,
		1
	],
	"../pages/cliente-novo/cliente-novo.module": [
		338,
		0
	],
	"../pages/cliente/cliente.module": [
		339,
		10
	],
	"../pages/login/login.module": [
		340,
		9
	],
	"../pages/pedido-detail/pedido-detail.module": [
		341,
		8
	],
	"../pages/pedido-novo/pedido-novo.module": [
		342,
		7
	],
	"../pages/pedido/pedido.module": [
		343,
		6
	],
	"../pages/produto-detail/produto-detail.module": [
		344,
		5
	],
	"../pages/produto/produto.module": [
		345,
		4
	],
	"../pages/settings/settings.module": [
		346,
		3
	],
	"../pages/tabs/tabs.module": [
		347,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 183;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 183
// module chunks = 11